module.exports = __webpack_public_path__ + "static/media/diktat-intro.97aa18cc.mp3";